module.exports = __webpack_public_path__ + "e5e439299c466d93b681d86bd51c3e4a.gif";